import Image from 'next/image';
import config from '../config';
import { useAlgo } from '../hooks/useAlgo';
import Button from './Button';
import ConnectWalletMessage from './ConnectWalletMessage';
import Container from './Container';
import OptInButton from './OptInButton';
import PageHeader from './PageHeader';

function TheTreatsPage() {
  const { address } = useAlgo();

  return (
    <main className='mb-12 md:mb-48'>
      <PageHeader
        heading='Shitty Treats'
        description='Collect treats for your each Shitty Kitty you own. You will be able to use these Shitty Treats in upcoming utilities. Connect your wallet below to opt-in.'
      >
        <div className='flex'>
          {address ? (
            <OptInButton assetId={parseInt(process.env.NEXT_PUBLIC_TREAT_TOKEN_ID)}>Opt-in to Shitty Treats</OptInButton>
          ) : (
            <ConnectWalletMessage label='Connect wallet to opt-in to $TREATS' bgClassName='bg-gray-800' />
          )}
        </div>
      </PageHeader>

      <div className='mt-16 md:mt-32'>
        <div className='relative'>
          <Container>
            <div className='lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24'>
              <div className='max-w-xl mx-auto lg:py-16 lg:max-w-none lg:mx-0'>
                <div className='mt-6'>
                  <h2 className='text-3xl font-extrabold tracking-tight text-neutral-100'>Introducing Shitty Treats</h2>

                  <p className='mt-4 text-lg text-neutral-400'>
                    Shitty Treats ($TREAT) is an ASA that will be used for all upcoming Shitty Utilities. Holders will be rewarded every week via an
                    air drop based on how many Shitty Kitties are in the wallet at the time of the air drop.
                  </p>

                  <dl className='flex flex-col mt-6 space-y-4 md:flex-row md:space-y-0 md:space-x-12'>
                    <div className='flex flex-col'>
                      <dt className='order-2 text-base font-medium text-neutral-500'>ASA ID</dt>
                      <dd className='order-1 text-3xl font-extrabold text-white sm:text-3xl'>
                        <a href={`https://allo.info/asset/${process.env.NEXT_PUBLIC_TREAT_TOKEN_ID}`} target='_blank'>
                          {process.env.NEXT_PUBLIC_TREAT_TOKEN_ID}
                        </a>
                      </dd>
                    </div>
                    <div className='flex flex-col'>
                      <dt className='order-2 text-base font-medium text-neutral-500'>Total Treats</dt>
                      <dd className='order-1 text-3xl font-extrabold text-white sm:text-3xl'>420 billion</dd>
                    </div>
                  </dl>

                  <div className='mt-8'>
                    <Button
                      theme='outline'
                      href={`https://www.randgallery.com/algo-collection/?address=${process.env.NEXT_PUBLIC_TREAT_TOKEN_ID}`}
                      target='_blank'
                    >
                      View On Rand Gallery
                    </Button>
                  </div>
                </div>
              </div>
              <div className='mt-12 sm:mt-16 lg:mt-0'>
                <Image
                  width={600}
                  height={600}
                  className='w-full rounded-lg shadow-lg ring-1 ring-black ring-opacity-5'
                  src='/shitty-treats.png'
                  alt='shitty treats'
                />
              </div>
            </div>
          </Container>
        </div>

        <div className='pt-16 mt-16 md:mt-32 bg-neutral-900'>
          <Container>
            <div className='max-w-4xl mx-auto text-center'>
              <h2 className='text-3xl font-extrabold text-neutral-300 sm:text-4xl'>Air Drop Every Friday</h2>
              <p className='mt-3 text-xl text-neutral-500 sm:mt-4'>
                You will be air dropped Shitty Treats for each First Litter and Second Litter Shitty Kitty you own. Only Shitty Kitties held in your
                wallet will be counted.
              </p>
            </div>
          </Container>

          <div className='mt-10 bg-neutral-800 sm:pb-16'>
            <div className='relative'>
              <div className='absolute inset-0 h-1/2 bg-neutral-900' />
              <div className='relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
                <div className='max-w-4xl mx-auto'>
                  <dl className='rounded-t-lg shadow-lg bg-neutral-800 sm:grid sm:grid-cols-3 border-b border-neutral-900'>
                    <div className='flex flex-col p-6 text-center border-b border-neutral-900 sm:border-0 sm:border-r'>
                      <dt className='order-2 mt-2 text-lg font-medium leading-6 text-neutral-500'>First Litter</dt>
                      <dd className='order-1 text-4xl font-extrabold text-neutral-300'>16 Treats</dd>
                    </div>
                    <div className='flex flex-col p-6 text-center border-b border-neutral-900 sm:border-0 sm:border-r'>
                      <dt className='order-2 mt-2 text-lg font-medium leading-6 text-neutral-500'>Second Litter</dt>
                      <dd className='order-1 text-4xl font-extrabold text-neutral-300'>16 Treats</dd>
                    </div>
                    <div className='flex flex-col p-6 text-center'>
                      <dt className='order-2 mt-2 text-lg font-medium leading-6 text-neutral-500'>Third Litter</dt>
                      <dd className='order-1 text-4xl font-extrabold text-neutral-300'>8 Treats</dd>
                    </div>
                  </dl>

                  <dl className='rounded-b-lg shadow-lg bg-neutral-800 sm:grid sm:grid-cols-2'>
                    <div className='flex flex-col p-6 text-center border-b border-neutral-900 sm:border-0 sm:border-r'>
                      <dt className='order-2 mt-2 text-lg font-medium leading-6 text-neutral-500'>Fourth Litter</dt>
                      <dd className='order-1 text-4xl font-extrabold text-neutral-300'>4 Treats</dd>
                    </div>
                    <div className='flex flex-col p-6 text-center'>
                      <dt className='order-2 mt-2 text-lg font-medium leading-6 text-neutral-500'>Legendary</dt>
                      <dd className='order-1 text-4xl font-extrabold text-neutral-300'>24 Treats</dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='mt-16 md:mt-32'>
          <Container>
            <div className='max-w-4xl mx-auto text-center'>
              <h2 className='text-3xl font-extrabold text-neutral-300 sm:text-4xl'>Shitty Utilities</h2>
              <p className='mt-3 text-xl text-neutral-500 sm:mt-4'>
                Shitty Treats will be used for all upcoming Shitty Utilities. Be the first to know about new Shitty Utilities by joining our{' '}
                <a href={config.discord} className='font-bold underline transition-opacity duration-200 text-primary-500 hover:opacity-50'>
                  Discord
                </a>{' '}
                and following us on{' '}
                <a href={config.twitter} className='font-bold underline transition-opacity duration-200 text-primary-500 hover:opacity-50'>
                  𝕏
                </a>
                .
              </p>
            </div>
          </Container>
        </div>

        <div className='mt-16 md:mt-32'>
          <Container>
            <div className='flex flex-col items-center justify-center space-y-8'>
              <h2 className='text-3xl font-extrabold tracking-tight text-center text-neutral-100'>Shitty Treats Creator Wallet</h2>

              <div className='w-full overflow-hidden prose'>
                <pre className='text-center'>{process.env.NEXT_PUBLIC_TREAT_TOKEN_WALLET}</pre>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </main>
  );
}

export default TheTreatsPage;
